module.exports = " <account-list acct-list=$ctrl.acctList account-label=\"Bank Account Name\" add-change-handler=$ctrl.addChangeAcct> </account-list> ";